import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface LambdaVazaoParams {
  estacao_id: number;
  data_inicial: string; // 'YYYY-MM-DD'
  data_final: string;   // 'YYYY-MM-DD'
}

export interface LambdaVazaoResponse {
  success: boolean;
  data?: Record<string, unknown>;
  message?: string;
  lambda_status?: number;
  lambda_response?: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class LambdaVazaoService {
  private readonly apiUrl = `${environment.urlBase}/lambda-vazao`;

  constructor(private http: HttpClient) {}

  consultar(params: LambdaVazaoParams): Observable<LambdaVazaoResponse> {
    const httpParams = new HttpParams()
      .set('estacao_id', params.estacao_id.toString())
      .set('data_inicial', params.data_inicial)
      .set('data_final', params.data_final);

    return this.http.get<LambdaVazaoResponse>(this.apiUrl, { params: httpParams });
  }
}
